(function () {
  const productCache = {};

  async function addProductImage(link) {
    // Already processed or currently loading
    if (link.dataset.productImageLoaded || link.dataset.productImageLoading) return;

    link.dataset.productImageLoading = "true";

    try {
      const productUrl = link.href;

      if (!productCache[productUrl]) {
        productCache[productUrl] = fetch(productUrl + ".js").then(res => res.json());
      }

      const product = await productCache[productUrl];

      if (product.featured_image) {
        const img = document.createElement("img");
        img.className = "jdgm-product-image";
        img.src = product.featured_image;
        img.alt = product.title;

        link.prepend(img);

        link.dataset.productImageLoaded = "true";
      }
    } catch (e) {
      console.error(e);
    } finally {
      delete link.dataset.productImageLoading;
    }
  }

  function moveProductNames() {
    document.querySelectorAll(".jdgm-media-card").forEach((card) => {
      const ratingSection = card.querySelector(".jdgm-rating-section");
      const productName = card.querySelector(".jdgm-product-name");

      if (!ratingSection || !productName) return;

      // Move below rating
      if (productName.previousElementSibling !== ratingSection) {
        ratingSection.insertAdjacentElement("afterend", productName);
      }

      // Add product image
      const link = productName.querySelector("a");
      if (link) {
        addProductImage(link);
      }
    });
  }

  // Initial run
  moveProductNames();

  // Watch for Judge.me dynamically adding/updating cards
  const observer = new MutationObserver(() => {
    moveProductNames();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();